<div class="d-flex align-items-center branch-header-container" [class.beta-branch-container]="isBetaAccess">
  <div class="d-inline-block dropdown branch-dropdown" [class.beta-branch-dropdown]="isBetaAccess">
    <p-select
      #branchSelect
      *ngIf="(groupedRefs && branches.length + tags.length > 1) || isLoading"
      [options]="groupedRefs"
      [styleClass]="isBetaAccess ? 'appname-dropdown beta-branch-select' : 'appname-dropdown'"
      [(ngModel)]="selectedBranch"
      [filter]="true"
      filterBy="gitRefsName,refsName,name"
      [placeholder]="selectedBranchDispName"
      [group]="true"
      optionGroupLabel="label"
      optionGroupChildren="items"
      (onChange)="handleBranchSelectionChange($event)"
      [disabled]="!isBetaAccess && _config?.flags?.isApp_MergeStatus_InProgress"
    >
      <ng-template pTemplate="selectedItem">
        <div
          class="country-item country-item-value"
          *ngIf="selectedBranch && !isLoading"
          [pTooltip]="selectedBranch.refsName || ('DEVELOPMENT' | translate)"
          tooltipPosition="bottom"
          [tooltipOptions]="{ showDelay: 500 }"
        >
          <div>
            <i
              [class]="selectedBranch.refType === 'TAG' ? 'pi pi-tag mr-2' : (isBetaAccess ? 'beta-branch-icon' : 'custom-branch-header-icon')"
              aria-hidden="true"
            ></i>
            {{ selectedBranch.refsName || ('DEVELOPMENT' | translate) }}
          </div>
        </div>
        <div *ngIf="isLoading">
          <i [class]="isBetaAccess ? 'beta-branch-icon' : 'fa fa-code-branch mr-2'" aria-hidden="true"></i>
          {{ 'SELECT_BRANCH' | translate }}
        </div>
      </ng-template>
      <ng-template let-group pTemplate="group">
        <div class="d-flex align-items-center justify-content-between group-header">
          <span>{{ group.label }}</span>
          <button
            *ngIf="isBetaAccess && group.value === 'branches'"
            type="button"
            class="menu-btn-icon menu-btn-icon-inline"
            (click)="toggleBranchMenu($event)"
            [disabled]="isLoading || !selectedBranch || _config?.flags?.isApp_MergeStatus_InProgress"
          >
            <i class="pi pi-ellipsis-v"></i>
          </button>
        </div>
      </ng-template>
      <ng-template let-ref pTemplate="item">
        <div
          class="country-item d-flex align-items-center justify-content-between"
          [pTooltip]="ref.refsName || 'development'"
          tooltipPosition="right"
          [tooltipOptions]="{ showDelay: 500 }"
        >
          <span class="branch-name">{{ ref.refsName || 'development' }}</span>
          <span *ngIf="ref.isDefaultBranch && ref.refType === 'BRANCH'" class="default-badge">Default</span>
        </div>
      </ng-template>
    </p-select>
    <p-select
      *ngIf="branches.length + tags.length === 1"
      [options]="groupedRefs"
      [styleClass]="isBetaAccess ? 'appname-dropdown beta-branch-select' : 'appname-dropdown'"
      [(ngModel)]="selectedBranch"
      [disabled]="!isBetaAccess"
      [group]="true"
      optionGroupLabel="label"
      optionGroupChildren="items"
    >
      <ng-template pTemplate="selectedItem">
        <div
          class="country-item country-item-value"
          *ngIf="selectedBranch"
          [pTooltip]="selectedBranch.refsName || ('DEVELOPMENT' | translate)"
          tooltipPosition="bottom"
          [tooltipOptions]="{ showDelay: 500 }"
        >
          <div>
            <i
              [class]="selectedBranch.refType === 'TAG' ? 'pi pi-tag mr-2' : (isBetaAccess ? 'beta-branch-icon' : 'custom-branch-header-icon')"
              aria-hidden="true"
            ></i>
            {{ selectedBranch.refsName || ('DEVELOPMENT' | translate) }}
          </div>
        </div>
      </ng-template>
      <ng-template let-group pTemplate="group">
        <div class="d-flex align-items-center justify-content-between group-header">
          <span>{{ group.label }}</span>
          <button
            *ngIf="isBetaAccess && group.value === 'branches'"
            type="button"
            class="menu-btn-icon menu-btn-icon-inline"
            (click)="toggleBranchMenu($event)"
            [disabled]="isLoading || !selectedBranch || _config?.flags?.isApp_MergeStatus_InProgress"
          >
            <i class="pi pi-ellipsis-v"></i>
          </button>
        </div>
      </ng-template>
      <ng-template let-ref pTemplate="item">
        <div
          class="country-item d-flex align-items-center justify-content-between"
          [pTooltip]="ref.refsName || 'development'"
          tooltipPosition="right"
          [tooltipOptions]="{ showDelay: 500 }"
        >
          <span class="branch-name">{{ ref.refsName || 'development' }}</span>
          <span *ngIf="ref.isDefaultBranch && ref.refType === 'BRANCH'" class="default-badge">Default</span>
        </div>
      </ng-template>
    </p-select>
  </div>

  <div class="widget-content-right header-user-info branch-context-menu" *ngIf="!isBetaAccess">
    <button
      type="button"
      class="menu-btn-icon"
      (click)="toggleBranchMenu($event)"
      [disabled]="isLoading || !selectedBranch || _config?.flags?.isApp_MergeStatus_InProgress"
    >
      <i class="pi pi-ellipsis-v"></i>
    </button>
  </div>
  <p-menu
    #branchMenu
    [popup]="true"
    [model]="menuItems"
    appendTo="body"
    styleClass="branch-action-menu"
  ></p-menu>
</div>

<vb-create-branch-tag-popup
  [applicationRefsList]="refsNameList"
  [gitRepositoryRefsList]="gitRefsNameList"
  [selectedSourceBranch]="selectedBranch"
  [refType]="refTypeToCreate"
  (reloadRepoPopup)="loadBranches()"
>
</vb-create-branch-tag-popup>

<p-dialog
  [(visible)]="viewChangesDialogVisible"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [styleClass]="'view-changes-dialog viewchanges-popup'"
  (onHide)="closeViewChangesDialog()"
>
  <ng-template pTemplate="header">
    <span class="dialog-header">
      {{ 'VIEW_CHANGES_POPUP' | translate }} -
      <span class="dialog-subheader">{{ selectedBranch?.refsName || 'Branch' }}</span>
    </span>
  </ng-template>
  <vb-view-changes
    *ngIf="viewChangesDialogVisible && selectedBranch"
    [branchId]="selectedBranch?.sid || ''"
    [suiteMode]="selectedBranch.applicationType === 'SUITE'"
  ></vb-view-changes>
  <ng-template pTemplate="footer"> </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="mergeHistoryDialogVisible"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [styleClass]="'merge-history-dialog viewchanges-popup'"
  (onHide)="closeMergeHistoryDialog()"
>
  <ng-template pTemplate="header">
    <span class="dialog-header">
      {{ 'MERGE_HISTORY_POPUP' | translate }} -
      <span class="dialog-subheader">{{ selectedBranch?.refsName || 'Branch' }}</span>
    </span>
  </ng-template>
  <vb-merge-history
    *ngIf="mergeHistoryDialogVisible && selectedBranch"
    [branchId]="selectedBranch?.sid || ''"
    [branchName]="selectedBranch?.refsName || ''"
  ></vb-merge-history>
  <ng-template pTemplate="footer"> </ng-template>
</p-dialog>

<!-- Delete Branch Confirmation Dialog -->
<p-confirmDialog key="deleteBranchConfirmation" appendTo="body" [draggable]="false">
  <ng-template pTemplate="message" let-message>
    <div>
      <div class="mt-2">
        <span>{{ message.message }}</span>
      </div>
      <div class="d-flex align-items-center mt-2">
        <p-checkbox class="mr-2" [(ngModel)]="deleteGitBranch" [binary]="true" id="deleteGitBranchCheckbox" />
        <label class="mb-0" for="deleteGitBranchCheckbox">{{ 'DELETE_GIT_BRANCH_OPTION' | translate }}</label>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>

<!-- Delete Tag Confirmation Dialog -->
<p-confirmDialog key="deleteTagConfirmation" appendTo="body" [draggable]="false">
  <ng-template pTemplate="message" let-message>
    <div>
      <div class="mt-2">
        <span>{{ message.message }}</span>
      </div>
      <div class="d-flex align-items-center mt-2">
        <p-checkbox class="mr-2" [(ngModel)]="deleteGitTag" [binary]="true" id="deleteGitTagCheckbox" />
        <label class="mb-0" for="deleteGitTagCheckbox">{{ 'DELETE_GIT_TAG_OPTION' | translate }}</label>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>

<p-confirmDialog key="markAsDefaultConfirmation"></p-confirmDialog>

<p-confirmDialog key="branchDeleteNavigateConfirmation"> </p-confirmDialog>
